import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    templateUrl: './confirm-store-change-modal.component.html',
    standalone: false
})
export class ConfirmStoreChangeModalComponent {
    storeName: string;
    constructor(public activeModal: NgbActiveModal) { }

    confirm() {
        this.activeModal.close(true);
    }

    cancel() {
        this.activeModal.dismiss(false);
    }
}
